import FormBuilderContainer from '../FormBuilder/FormBuilderContainer';
import SequentialFormContainer from '../SequentialForm/SequentialFormContainer';
import { REMOVED_COMPONENT_REGISTRY_ENTRIES } from '../../utils/removedComponentTypes';

export const ComponentRegistry = [
  {
    name: 'ai_assistant',
    displayName: 'AI Request',
    description: 'Use AI to perform a task or action and return an output',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/ai_assistant.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#944BA8',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    hidden: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'ai_agent',
    displayName: 'AI Agent',
    description:
      'Invoke a configured AI agent with tools to perform multi-step reasoning and actions',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/ai_agent.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#944BA8',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    hidden: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'api_export',
    displayName: 'API Export',
    description: 'Make a HTTP POST to an API endpoint',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/api_export.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#788ac8',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'http_request',
    displayName: 'HTTP Request',
    description: 'Make HTTP requests to external APIs with support for all methods, headers, auth, and credentials',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/http_request.svg',
    stateless: false,
    interactive: true,
    baseColor: '#2a4cc2',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'api_request_and_response',
    displayName: 'API Request and Response',
    description: 'Make an API request and parse the data from the response',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/api_request_and_response.svg',
    stateless: false,
    interactive: true,
    baseColor: '#2a4cc2',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: true,
  },
  {
    name: 'sequential_form',
    displayName: 'Assign Task',
    description:
      'Assign someone a task to complete and run the next component when that task is completed',
    // discoveryEndpoint: "component-service/sequential_form/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/sequential_form.svg',
    sidebarLogo: '/svgs/sequential_form.svg',
    stateless: false,
    interactive: true,
    action: CanvasNodeWidget => {
      SequentialFormContainer.diagramEngine = CanvasNodeWidget.props.diagramEngine;
      SequentialFormContainer.node = CanvasNodeWidget.props.node;
      CanvasNodeWidget.props.navigate(
        window.location.pathname +
          `/sequential_form/${CanvasNodeWidget.props.node.extras.component_id || ''}`
      );
    },
    tier: 'FREE',
    baseColor: '#2670ff',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'branch_paths',
    displayName: 'Branch Paths',
    description: 'Branch workflow into Conditional Paths',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/branch_paths.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#000000',
    isTrigger: false,
    hasAccessControl: false,
    isAlwaysPublic: true,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'calculator',
    displayName: 'Calculator',
    description: 'Perform a calculation',
    // discoveryEndpoint: "component-service/calculator/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/calculator.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#ff7e7e',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'code',
    displayName: 'Run Code',
    description: 'Run custom Python or Javascript code',
    // discoveryEndpoint: "component-service/code/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/code.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#000000',
    isTrigger: false,
    hasAccessControl: false,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'conditional_logic',
    displayName: 'Conditional Logic',
    description: 'Run a logic statement to set the value of a variable/placeholder',
    // discoveryEndpoint: "component-service/conditional-logic/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/conditional_logic.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#9cc5c5',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'conditional_workflow',
    displayName: 'Conditional Path',
    description:
      'Control whether the workflow continues to the next action or stops based on a logic statement',
    // discoveryEndpoint: "component-service/conditional-workflow/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/conditional_workflow.svg',
    stateless: false,
    interactive: true,
    fromWorkflowPath: false,
    tier: 'FREE',
    baseColor: '#FF7E3E',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'conditional_workflow_path',
    displayName: 'Conditional Workflow Paths',
    description: 'Create paths that run based on a conditional statement',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/conditional_workflow_path.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#868686',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
  },

  {
    name: 'create_database_record',
    displayName: 'Create Table Record',
    description: 'Create a new row/record in a table to store information or data',
    // discoveryEndpoint: "component-service/create_database_record/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/create_database_record.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#E10050',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'document_editor',
    displayName: 'Document Editor',
    description: 'Generate word or PDF documents from a template',
    // discoveryEndpoint: "component-service/document-editor/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/report.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#ed6696',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'create_file',
    displayName: 'Create File',
    description: 'Generate files (CSV, JSON, PDF, XLSX, TXT, MD, DOCX) from templates and data',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/create_file.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#2e7d32',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'email',
    displayName: 'Email',
    description: 'Send an email',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/email.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#ffb74d',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'form',
    displayName: 'Form',
    description: 'Online form which triggers a workflow when submitted',
    // discoveryEndpoint: "component-service/form/placeholder",
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/form.svg',
    sidebarLogo: '/svgs/form.svg',
    stateless: false,
    interactive: true,
    action: CanvasNodeWidget => {
      FormBuilderContainer.diagramEngine = CanvasNodeWidget.props.diagramEngine;
      FormBuilderContainer.node = CanvasNodeWidget.props.node;
      CanvasNodeWidget.props.navigate(
        window.location.pathname +
          `/formbuilder/${CanvasNodeWidget.props.node.extras.component_id || ''}`
      );
    },
    tier: 'FREE',
    baseColor: '#7ac0f8',
    isTrigger: true,
    hasAccessControl: true,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'form_section',
    displayName: 'Form Section',
    description:
      'Redirect the user to another form section when a previous form or task has been submitted',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/form.svg',
    sidebarLogo: '/svgs/form.svg',
    stateless: false,
    interactive: true,
    action: CanvasNodeWidget => {
      SequentialFormContainer.diagramEngine = CanvasNodeWidget.props.diagramEngine;
      SequentialFormContainer.node = CanvasNodeWidget.props.node;
      CanvasNodeWidget.props.navigate(
        window.location.pathname +
          `/form_section/${CanvasNodeWidget.props.node.extras.component_id || ''}`
      );
    },
    tier: 'FREE',
    baseColor: '#7ac0f8',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'list_transform',
    displayName: 'List Transform',
    description: 'Transform and manipulate list type data',
    // discoveryEndpoint: "component-service/list-transform/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/list_transform.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#48a80f',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: true,
  },
  {
    name: 'loop_through_list',
    displayName: 'Split into Threads',
    description:
      'Split a list into individual values and start a parallel run of all further components for each individual value',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/loop_through_list.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#48A80F',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'merge_workflow',
    displayName: 'Merge Paths',
    description:
      'Merge multiple workflow paths together and trigger a component when one or more connections have been completed',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/merge_workflow.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#ff3d00',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'converge_threads',
    displayName: 'Merge Threads',
    description: 'Wait for all thread runs to complete, then continue once with merged output',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/converge_threads.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#48A80F',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'parse_json',
    displayName: 'Parse JSON',
    description: 'Parse a JSON into placeholder values',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/parse_json.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#001356',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: true,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'query_database_record',
    displayName: 'Query Table',
    description:
      'Query a table and return all values in a column or return values from a column based on a conditional statement',
    // discoveryEndpoint: "component-service/query_database_record/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/query_database.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#E10050',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'schedule_start',
    displayName: 'Schedule Start',
    description: 'Start this workflow a certain time or date',
    // discoveryEndpoint: "component-service/schedule-start/placeholder",
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/schedule_start.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#1D7573',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'slack',
    displayName: 'Send Slack Message',
    description: 'Send a Slack message',
    // discoveryEndpoint: "component-service/slack/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/slack.svg',
    stateless: false,
    interactive: true,
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'session_variables',
    displayName: 'Session Variables',
    description: 'Create variables/placeholders that can be used in the rest of the workflow',
    // discoveryEndpoint: "component-service/code/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/session_variables.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#000000',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: false,
  },

  {
    name: 'time_delay',
    displayName: 'Time Delay',
    description: 'Delay the next action until a certain time or date',
    // discoveryEndpoint: "component-service/time-delay/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/time_delay.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#67C9D3',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_a_zap',
    displayName: 'Trigger a Zap',
    description: 'Trigger a zap in Zapier',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/zapier-icon.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#FF4A00',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_from_zapier',
    displayName: 'Trigger from Zapier',
    description: 'Trigger a workflow from a zap in Zapier',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/zapier-icon.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#FF4A00',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_from_external_app',
    displayName: 'Trigger from External App',
    description: 'Trigger a workflow from an External App',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/trigger_from_external_app.svg',
    stateless: false,
    interactive: true,
    tier: 'CUSTOM',
    baseColor: '#5585A7',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'perform_action_in_external_app',
    displayName: 'Perform Action in External App',
    description: 'Perform an action in an External App',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/perform_action_in_external_app.svg',
    stateless: false,
    interactive: true,
    tier: 'CUSTOM',
    baseColor: '#5585A7',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_another_workflow',
    displayName: 'Trigger another Workflow',
    description: 'Trigger a separate workflow or create a loop',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/trigger_another_workflow.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#868686',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_from_a_workflow',
    displayName: 'Trigger from a Workflow',
    description: 'Trigger this workflow when another workflow is run or create a loop',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/trigger_from_a_workflow.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#2C2C2C',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_via_email',
    displayName: 'Trigger via Email',
    description: 'Trigger this workflow when an email is received at a specific email address',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/trigger_via_email.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#FFB800',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'update_database_record',
    displayName: 'Update Table Record',
    description: 'Update the values in a row/record in a table',
    // discoveryEndpoint: "component-service/update_database_record/placeholder",
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/update_database_record.svg',
    stateless: false,
    interactive: true,
    baseColor: '#E10050',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_on_database_update',
    displayName: 'Trigger on Table Update',
    description: 'Trigger this workflow when a record in a table is updated',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/trigger_on_database_update.svg',
    stateless: false,
    interactive: true,
    baseColor: '#E10050',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'query_table_v2',
    displayName: 'Query Table',
    description: 'Query a table with full SQL-like capabilities: nested conditions, aggregation, sorting, and column projection',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/query_database.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#E10050',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'create_row_v2',
    displayName: 'Create Row',
    description: 'Create a new row in a table with typed column values',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/create_database_record.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#E10050',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'update_row_v2',
    displayName: 'Update Row',
    description: 'Update an existing row in a table by row ID',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/update_database_record.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#E10050',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'trigger_table_v2',
    displayName: 'Table Trigger',
    description: 'Trigger a workflow when a row is inserted, updated, or deleted in a table',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/trigger_on_database_update.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#E10050',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'trigger_on_artifact',
    displayName: 'Artifact Trigger',
    description: 'Trigger a workflow when an artifact is submitted',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/artifact.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#2670ff',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'create_board_ticket',
    displayName: 'Create Board Ticket',
    description: 'Create a new ticket on an agentic-kanban board',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/create_board_ticket.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#00897B',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'get_board_ticket',
    displayName: 'Get Board Ticket',
    description: 'Read a ticket from a board by ticket ID',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/get_board_ticket.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#00897B',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'update_board_ticket',
    displayName: 'Update Board Ticket',
    description: 'Update fields on an existing board ticket',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/update_board_ticket.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#00897B',
    isTrigger: false,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_on_board_ticket',
    displayName: 'Trigger on Board Ticket',
    description: 'Trigger this workflow when a board ticket is created, updated, or moved',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/trigger_on_board_ticket.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#00897B',
    isTrigger: true,
    hasAccessControl: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'bulk_assessment',
    displayName: 'Upload Spreadsheet',
    description: 'Upload a spreadsheet and trigger a workflow session for each row',
    // discoveryEndpoint: "component-service/bulk_assessment/placeholder",
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/bulk_assessment.svg',
    sidebarLogo: '/svgs/bulk_assessment.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#5bc4b0',
    isTrigger: true,
    hasAccessControl: true,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'webhook_trigger_v2',
    displayName: 'Webhook Trigger',
    description: 'Trigger a workflow via webhook',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/webhook_trigger.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#42A5F5',
    isTrigger: true,
    hasAccessControl: true,
    isAlwaysPublic: true,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'webhook_trigger',
    displayName: 'Webhook Trigger (Legacy Type)',
    description: 'Legacy saved webhook trigger type; new workflows use Webhook Trigger',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/webhook_trigger.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#42A5F5',
    isTrigger: true,
    hasAccessControl: true,
    isAlwaysPublic: true,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'webhook',
    displayName: 'Webhook Import (Legacy)',
    description: 'Trigger a workflow when a webhook is received',
    // discoveryEndpoint: "component-service/webhook/placeholder",
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/webhook.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#8add9e',
    isTrigger: true,
    hasAccessControl: true,
    isAlwaysPublic: true,
    isExcluded: true,
    isFloatingIcon: false,
  },
  {
    name: 'trigger_from_api_polling',
    displayName: 'Trigger from API Polling',
    description: 'Trigger a workflow by polling an API at regular intervals',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/trigger_from_api_polling.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#0288D1',
    isTrigger: true,
    hasAccessControl: false,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'await_external_event',
    displayName: 'Await External Event',
    description: 'Pause and wait for an external event (webhook or API polling) before continuing',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/await_external_event.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#00897B',
    isTrigger: false,
    hasAccessControl: false,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'UI.dbIcon',
    displayName: 'Table',
    description: 'A Workflow86 table',
    logo: '/svgs/database.svg',
    stateless: false,
    interactive: false,
    tier: 'FREE',
    baseColor: '#1C1B1F',
    hasAccessControl: true,
    isAlwaysPublic: true,
    newTabUrl: '/databases/database_management',
    hidden: true,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'dynamic_form',
    displayName: 'Dynamic Form',
    description: 'Create a dynamic form that triggers a workflow when submitted',
    hasInput: false,
    hasOutput: true,
    logo: '/svgs/form.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#2670ff',
    isTrigger: true,
    hasAccessControl: true,
    isAlwaysPublic: false,
    hidden: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'dynamic_review_task',
    displayName: 'Create Task',
    description: 'Assign a dynamic form to a user and pause until they submit',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/sequential_form.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#2670ff',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    hidden: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'form_step',
    displayName: 'Form Step',
    description: 'Self-service mid-workflow form step. Can start or attach to a form flow.',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/form.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#2670ff',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    hidden: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'artifact',
    displayName: 'Artifact',
    description: 'Create a human-facing artifact and wait for a submitted event',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/artifact.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#2670ff',
    isTrigger: false,
    hasAccessControl: true,
    isAlwaysPublic: false,
    hidden: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
  {
    name: 'gateway',
    displayName: 'Gateway',
    description: 'Route workflow based on conditions or fan out to all paths',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/gateway.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#F5A623',
    isTrigger: false,
    hasAccessControl: false,
    isAlwaysPublic: true,
    isExcluded: false,
    isFloatingIcon: false,
  },
  {
    name: 'custom_function',
    displayName: 'Custom Function',
    description:
      'Run a tenant-defined custom function. Pick the function in the drawer; inputs and outputs derive from its schemas.',
    hasInput: true,
    hasOutput: true,
    logo: '/svgs/custom_function.svg',
    stateless: false,
    interactive: true,
    tier: 'FREE',
    baseColor: '#944BA8',
    isTrigger: false,
    hasAccessControl: false,
    isAlwaysPublic: false,
    isExcluded: false,
    isFloatingIcon: true,
  },
];

export default ComponentRegistry;

function createFactory(ComponentRegistry) {
  const node_factory = {};
  ComponentRegistry.forEach(registered_node => {
    node_factory[registered_node.name] = {
      hidden: registered_node.hidden,
      name: registered_node.name,
      logo: registered_node.logo,
      sidebarLogo: registered_node.sidebarLogo,
      description: registered_node.description,
      isInteractive: registered_node.interactive,
      displayName: registered_node.displayName,
      tier: registered_node.tier,
      baseColor: registered_node.baseColor,
      isTrigger: registered_node.isTrigger,
      hasAccessControl: registered_node.hasAccessControl,
      isAlwaysPublic: registered_node.isAlwaysPublic,
      hasOutput: registered_node.hasOutput,
      hasInput: registered_node.hasInput,
      newTabUrl: registered_node.newTabUrl,
      fromWorkflowPath: registered_node.fromWorkflowPath,
      isExcluded: registered_node.isExcluded,
      isFloatingIcon: registered_node.isFloatingIcon,
      isRemoved: registered_node.isRemoved === true,
    };
  });
  return node_factory;
}

export const ComponentFactory = createFactory([
  ...ComponentRegistry,
  ...REMOVED_COMPONENT_REGISTRY_ENTRIES,
]);

/**
 * Single source of truth for component tier entitlement. A component's registry
 * `tier` is the minimum entitlement: only `CUSTOM` components are gated (CUSTOM
 * users only); every other tier value is available to all users. Consumers must
 * read this instead of hardcoding tier strings so the registry stays authoritative.
 */
export const isComponentTierUnlocked = (requiredTier, userTier) =>
  requiredTier !== 'CUSTOM' || userTier === 'CUSTOM';
